class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.setupMobileGestures();
    this.setupNoteToggle();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setupMobileGestures();
      this.setupNoteToggle();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setupMobileGestures() {
    if (this._mobileGesturesBound) return;
    this._mobileGesturesBound = true;

    let startY = 0, deltaY = 0, inner = null;

    document.addEventListener('touchstart', (e) => {
      if (!this.classList.contains('active')) return;
      const target = e.target.closest('.drawer__handle, .drawer__header');
      if (!target || !this.contains(target)) return;
      inner = this.querySelector('.drawer__inner');
      if (!inner) return;
      startY = e.touches[0].clientY;
      deltaY = 0;
      inner.style.transition = 'none';
    }, { passive: true });

    document.addEventListener('touchmove', (e) => {
      if (!inner) return;
      deltaY = e.touches[0].clientY - startY;
      if (deltaY > 0) inner.style.transform = `translateY(${deltaY}px)`;
    }, { passive: true });

    document.addEventListener('touchend', () => {
      if (!inner) return;
      inner.style.transition = '';
      inner.style.transform = '';
      if (deltaY > 100) this.close();
      inner = null;
    });
  }

  setupNoteToggle() {
    const toggle = this.querySelector('.cart-drawer__note-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const wrapper = toggle.closest('.cart-drawer__note-wrapper');
      const isOpen = wrapper.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        const textarea = wrapper.querySelector('.cart-drawer__note-textarea');
        if (textarea) textarea.focus();
      } else {
        const textarea = wrapper.querySelector('.cart-drawer__note-textarea');
        if (textarea) {
          const noteValue = textarea.value.trim();
          let display = wrapper.querySelector('.cart-drawer__note-display');
          if (noteValue) {
            if (!display) {
              display = document.createElement('div');
              display.className = 'cart-drawer__note-display';
              wrapper.querySelector('.cart-drawer__note-header').after(display);
            }
            display.textContent = noteValue;
          } else if (display) {
            display.remove();
          }
        }
      }
    });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
